import { useAuth } from "../../auth/AuthContext";

/**
 * The persistent strip under the header of a guest session (KEY-297): who they are here as, and when the
 * access ends. Deliberately always visible — a guest should never mistake themselves for a member, and an
 * admin looking over their shoulder should see at a glance that this is invited access.
 */
export function GuestBanner() {
  const { me, guestAccessExpiresAt } = useAuth();

  const ends = guestAccessExpiresAt ? new Date(guestAccessExpiresAt) : null;
  const endsText =
    ends && !Number.isNaN(ends.getTime())
      ? ends.toLocaleDateString(undefined, { day: "numeric", month: "short" })
      : null;

  return (
    <div
      role="status"
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: 8,
        padding: "7px 14px",
        fontSize: 13,
        background: "var(--accent-soft)",
        color: "var(--accent-text)",
        borderBottom: "var(--border-w) solid var(--border)",
      }}
    >
      <span style={{ fontWeight: 600 }}>Guest access</span>
      <span aria-hidden>·</span>
      <span>
        You&rsquo;re viewing as {me?.displayName || me?.email || "a guest"}
        {endsText ? ` — access ends ${endsText}` : ""}
      </span>
    </div>
  );
}
